/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Agen_GInputs */

const en_mk_tut_agen_g = /** @type {(inputs: Mk_Tut_Agen_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is the part that makes this product different. Assigning an agent is exactly like assigning a person — you pick it in the assignee field.`)
};

const id_mk_tut_agen_g = /** @type {(inputs: Mk_Tut_Agen_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inilah bagian yang membedakan produk ini. Menugaskan agen sama persis dengan menugaskan orang — Anda memilihnya di kolom penanggung jawab.`)
};

/**
* | output |
* | --- |
* | "This is the part that makes this product different. Assigning an agent is exactly like assigning a person — you pick it in the assignee field." |
*
* @param {Mk_Tut_Agen_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_agen_g = /** @type {((inputs?: Mk_Tut_Agen_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Agen_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_agen_g(inputs)
	return en_mk_tut_agen_g(inputs)
});